import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useLayoutEffect,
} from "react";
import {
  GoogleMap,
  StandaloneSearchBox,
  LoadScript,
} from "@react-google-maps/api";
import env from "../../config.json";
import Pin from "../../assets/imgs/icons/pin.png";
import CabServices from "../../services/externalServices/cab/CabServices";
import TourPackageServices from "../../services/externalServices/tourPackages/TourPackageServices";
import PersonCount from "./NumberOfPersons";
import CruzeTypes from "./components/CruzeTypes";
import { getDistanceBetweenCoordinates } from "../../utils/functions/geoUtils";
import moment from "moment";

import {
  sendNotificationBidRequest,
  sendNotificationBidNotAccepted,
} from "../../utils/functions/notification";
import BiddingList from "./BiddingList";
import releaseRidersFromBidLock from "../../utils/functions/riders";
import BidServices from "../../services/externalServices/bids/BidServices";
import { useNavigate } from "react-router-dom";
import { useSelector, useStore, useDispatch } from "react-redux";
import { AuthModal } from "../userLogin/AuthModal";
import { useLocation } from "react-router-dom";
import PickupMap from "./components/PickupMap";
import CityServices from "../../services/externalServices/cityServices/CityServices";
// import {moment} from "moment";
import { Sheet } from "react-modal-sheet";
import MapViewBidding from "./components/MapViewBidding";
import { setPickupLocation } from "../../redux/slices/pickupLocationSlice";
// import { setIsConfirmBooked } from "../../redux/slices/packageSlice";
import { setIsConfirmBooked } from "../../redux/slices/bookingSlice";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import ConfirmationModal from "./components/ConfirmationModal";
import SearchStopped from "./components/SearchStopped";
import NoOnlineDrivers from "./components/NoOnlineDrivers";
import { forwardRef, useImperativeHandle } from "react";
import ToggleButton from "./components/ToggleButton";

const API_KEY = env.GOOGLE_MAP_API_KEY;
const CITY_ID = "6797a273235d0108e075d7d7";

let initialRadius = 0;
let incrementByRadius = 1;
let maxRadius = 10;
let waitTimeBetweenRadius = 30 * 1000;
let waitTimeAfterSearchComplete = 300;
let bidCountToStopSearch = 3;

const containerStyle = {
  width: "100%",
  height: "300px",
};

const defaultCenter = {
  lat: 15.26497032374632,
  lng: 76.38350725813741,
};

const hospetBounds = {
  north: 15.3375, // Approximate boundary for Hospet
  south: 15.23,
  east: 76.44,
  west: 76.32,
};

const engagingMessages = [
  "Hang tight! We're checking with more drivers nearby.",
  "Still looking... Good things take time! 🚕",
  "Almost there! Thanks for being patient.",
  "Your ride is important to us — searching continues...",
  "We're making sure you get the best driver available.",
];

const waitingMessages = [
  "Your request is with the driver — stay tuned!",
  "Drivers are evaluating your trip. Almost there!",
  "Thanks for your patience — we’re getting you the best option.",
  "Your ride is being reviewed by nearby drivers.",
  "Hold tight! A driver may accept your trip shortly.",
];

// const defaultCenter = {
//   lat: 15.049781494003552,
//   lng: 76.60536173171086,
// };
// , 76.38350725813741
// 15.049781494003552, 76.60536173171086

const getMinTime = (selectedDate) => {
  const today = moment().format("YYYY-MM-DD");

  if (selectedDate === today) {
    const currentTime = moment().format("HH:mm"); // Current time if today

    return currentTime;
  }

  return "07:00"; // Default minTime for future dates
};
// const BookTour = forwardRef(({
//   id,
//   selectedPackageDetails,
//   setSearchingInProgress,
//   setFilteredRiders,
//   searchRadius, // Add this
//   setSearchRadius, // Add this
//   // incrementByRadius,     // Add if needed
//   // setIncrementByRadius
//   // setPickupLocation
// },ref)=> {
const BookTour = forwardRef(
  (
    {
      id,
      selectedPackageDetails,
      setSearchingInProgress,
      setFilteredRiders,
      searchRadius,
      setSearchRadius,
      isCabrequestCancelled,
      setIsCabrequestCancelled,
    },
    ref,
  ) => {
    const location = useLocation();
    const dispatch = useDispatch();

    // Access pickup location from Redux
    const pickupLocation = useSelector((state) => state.pickupLocation);
    const isConfirmBooked = useSelector(
      (state) => state.bookingConfirm.isConfirmBooked,
    );
    // const selectedPackageDetails = location.state?.selectedPackage || null;
    // const bookBeforeTime = "2024-12-07T08:00:00.000Z";
    console.log("selectedPackageDetails", selectedPackageDetails);

    const getTodayDate = () => {
      const today = moment(); // Current local time
      const localBookBeforeTime = moment(
        selectedPackageDetails?.bookBeforeTime,
      ).utcOffset(moment().utcOffset()); // Convert to local time

      console.log("Current Time:", today.format("HH:mm"));
      console.log("Cutoff Time:", localBookBeforeTime.format("HH:mm"));

      // Compare only the time (HH:mm)
      if (
        today.hour() > localBookBeforeTime.hour() ||
        (today.hour() === localBookBeforeTime.hour() &&
          today.minute() > localBookBeforeTime.minute())
      ) {
        console.log("Current time is greater than cutoff time");
        // setInfoMessage("Today's booking time is over. Setting it to next day.");
        const tomorrow = today.clone().add(1, "days"); // Clone before modifying
        console.log("Tomorrow's Date:", tomorrow.format("YYYY-MM-DD"));
        return tomorrow.format("YYYY-MM-DD"); // Return tomorrow's date
      }

      return today.format("YYYY-MM-DD"); // Return today's date if within valid time
    };

    //  const [minSelectableDate, setMinSelectableDate] = useState(getTodayDate());
    const [infoMessage, setInfoMessage] = useState("");

    console.log("getTodayDate", getTodayDate());

    const [showForm, setShowForm] = useState(false);
    const [showPickupMap, setShowPickupMap] = useState(false);
    const [showDropMap, setShowDropMap] = useState(false);
    const serviceAssociated = "TourPackage";
    // const [searchRadius, setSearchRadius] = useState(initialRadius);
    const [isCreatingSR, setIsCreatingSR] = useState(false);
    // const [filteredRiders, setFilteredRiders] = useState([]);
    const [bidFcmTokens, setBidFcmTokens] = useState([]);
    const [bidPhoneNumbers, setBidPhoneNumbers] = useState([]);
    const [bids, setBids] = useState([]);
    const [personsCount, setPersonsCount] = useState(2);
    const [selectedCruzeIds, setSelectedCruzeIds] = useState(null);
    const [cabRequestId, setCabRequestId] = useState(null);
    const [isFetchingRiders, setIsFetchingRiders] = useState(false);
    const [ridersFound, setRidersFound] = useState(null);
    const [partnersList, setPartnersList] = useState(null);
    const [searchingInProgress, setSearching] = useState(true);
    const [isCreatingTrip, setCreatingTrip] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isAuthOpen, setIsAuthOpen] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const LoggedInState = useSelector((state) => state.user.loggedInState);
    // console.log("LoggedInState", LoggedInState);
    // const [pickupLocation, setPickupLocation] = useState({
    //   latitude: null,
    //   longitude: null,
    //   title: "",
    //   subtext: "",
    //   place_id: "",
    // });
    const [dropLocation, setDropLocation] = useState({
      latitude: null,
      longitude: null,
      title: "",
      subtext: "",
      place_id: "",
    });
    const [number, setNumber] = useState(1);
    const [notifiedRiders, setNotifiedRiders] = useState([]);
    const [waitingStart, setWaitingStart] = useState(false);
    const [stopSearch, setStopSearch] = useState(false);
    const [isSendingNotifications, setIsSendingNotifications] = useState(false);
    const [isFutureDateSelected, setFutureDateSelected] = useState(null);
    const [formData, setFormData] = useState({
      date: moment(),
      time: moment(),
      pickup: "",
      drop: "",
    });
    // const [selectedDate, setSelectedDate] = useState(
    //   moment().format("YYYY-MM-DD")
    // );
    const [selectedDate, setSelectedDate] = useState(getTodayDate());
    // const [selectedTime, setSelectedTime] = useState(
    //   moment("07:00", "HH:mm").format("HH:mm")
    // );
    const [selectedTime, setSelectedTime] = useState("");
    // const [isConfirmBooked, setIsConfirmBooked] = useState(false);

    const pickupRef = useRef(null);
    const dropRef = useRef(null);
    const pickupMapRef = useRef(null);
    const dropMapRef = useRef(null);

    const [mapCenter, setMapCenter] = useState(defaultCenter);
    const [activeType, setActiveType] = useState(null); // To track pickup or drop
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [snapTo, setSnapTo] = useState(["35%", "95%"]);
    const [errors, setErrors] = useState({});
    const [isFormValid, setIsFormValid] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const navigate = useNavigate();
    const user = useSelector((state) => state.user.user);
    const [timeError, setTimeError] = useState("");
    const [polygonCoordinates, setPolygonCoordinates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isCurrentScreen, setIsCurrentScreen] = useState(false);
    const [reviewEndTime, setReviewEndTime] = useState([]);
    const [currentTime, setCurrentTime] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [modalCancelVisible, setModalCancelVisible] = useState(false);
    const [isBackConfirmed, setIsBackConfirmed] = useState(false);
    const [currentSnap, setCurrentSnap] = useState(0);
    const [acType, setAcType] = useState("AC");

    const [engagementMsgIndex, setEngagementMsgIndex] = useState(0);
    const [waitingMsgIndex, setWaitingMsgIndex] = useState(0);
    const [hasCancelled, setHasCancelled] = useState(false);

    // const [searchRadius, setSearchRadius] = useState(initialRadius);
    // let lastUpdateTime = null;
    const lastUpdateTimeRef = useRef(null);
    console.log("Package user=======", user);
    const ref1 = useRef < import("react-modal-sheet").SheetRef > null;

    useEffect(() => {
      const minTime = getMinTime(selectedDate);
      setSelectedTime(minTime);
    }, [selectedDate]);

    useEffect(() => {
      const today = moment().format("YYYY-MM-DD");
      const computedMinDate = getTodayDate();
      // setMinSelectableDate(computedMinDate);

      if (computedMinDate !== today) {
        setInfoMessage("Today's booking time is over. Setting it to next day.");

        const timer = setTimeout(() => {
          setInfoMessage("");
        }, 4000); // 4000 ms = 4 seconds

        return () => clearTimeout(timer); // Cleanup if component unmounts
      } else {
        setInfoMessage("");
      }
    }, [selectedPackageDetails]);

    useEffect(() => {
      if (searchingInProgress && bids?.length === 0) {
        const interval = setInterval(() => {
          setEngagementMsgIndex((prev) => (prev + 1) % engagingMessages.length);
        }, 7000); // Change every 5 seconds

        return () => clearInterval(interval);
      }
    }, [searchingInProgress, bids]);
    useEffect(() => {
      if (waitingStart && bids?.length === 0) {
        const interval = setInterval(() => {
          setWaitingMsgIndex((prev) => (prev + 1) % waitingMessages.length);
        }, 5000);
        return () => clearInterval(interval);
      }
    }, [waitingStart, bids]);

    //   const combinedDateTime = new Date(
    //     `${formData.date}T${formData.time}:00.000Zie`
    //   );
    //   const formattedDateTime = new Date(combinedDateTime).toISOString();

    // //   const localDateTime = new Date(`${formData.date}T${formData.time}:00`);
    // // const utcDateTime = new Date(localDateTime.getTime() - localDateTime.getTimezoneOffset() * 60000);
    // // const formattedDateTime = new Date(`${formData.date}${formData.time}`).toISOString();

    // console.log("Formatted UTC DateTime:", formattedDateTime);

    // const localDateTime = new Date(`${formData.date}T${formData.time}:00`);

    // Store as local time (without converting to UTC)
    // const formattedDateTime = localDateTime.toISOString() // Removes 'Z'
    // const formattedTime = formData.time.toISOString();
    // const formattedDate = formData.date.toISOString();

    const calculateRemainingTime = (reviewEndTime, currentTime) => {
      console.warn("calculateRemainingTime ", reviewEndTime, currentTime);
      const endTime = new Date(reviewEndTime).getTime();
      const now = new Date(currentTime).getTime();
      return Math.max(Math.floor((endTime - now) / 1000), 0); // Ensure non-negative values
    };
    const [remainingTime, setRemainingTime] = useState(() =>
      calculateRemainingTime(reviewEndTime, currentTime),
    );

    let formattedTime;
    // const formattedTime = new Date(
    //   `${selectedDate} ${selectedTime}`
    // ).toISOString();
    // console.log("formattedTime",formattedTime)
    // console.log("selectedDate",selectedDate)
    // console.log("selectedTime",selectedTime)

    if (selectedDate && selectedTime) {
      const dateTimeString = `${selectedDate}T${selectedTime}`;
      const parsedDate = new Date(dateTimeString);

      if (!isNaN(parsedDate)) {
        formattedTime = parsedDate.toISOString();
        console.log("formattedTime", formattedTime);
      } else {
        console.error("Invalid date string for Safari:", dateTimeString);
      }
    } else {
      console.error("Missing selectedDate or selectedTime");
    }
    // const formattedTime = new Date(`${selectedDate}T${selectedTime}`).toISOString();
    let formattedDate;
    if (selectedDate) {
      formattedDate = new Date(selectedDate).toISOString();
      // do something with isoDate
    }

    // const formattedDate = new Date(selectedDate).toISOString();

    console.log("Formatted Local DateTime:", formattedTime, formattedDate);

    useEffect(() => {
      CityServices.getAllCityGroupedByBlock()
        .then((response) => {
          const groupedByBlock = response.data;

          console.warn("new block incuded-***************", groupedByBlock);

          const blockCoordinates = Object.values(groupedByBlock).map(
            (blockCities) => {
              return blockCities
                .filter((city) => city.serviceType == "Tour") // Filter cities where serviceType is "Auto"
                .map((city) => ({
                  latitude: parseFloat(city.latitude),
                  longitude: parseFloat(city.longitude),
                }));
            },
          );

          console.warn(
            "new block incuded-blockCoordinates***************",
            blockCoordinates,
          );

          console.error("New blockCoordinates -> ", blockCoordinates);
          // console.error(JSON.stringify(blockCoordinates, null, 2))
          // Set the filtered block coordinates
          setPolygonCoordinates(blockCoordinates);

          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching city data:", error);
          setLoading(false);
        });
    }, [LoggedInState]);

    useEffect(() => {
      // ✅ Cleanup function runs when the component is unmounted (navigating away)
      return () => {
        dispatch(setIsConfirmBooked(false));
      };
    }, [dispatch, navigate]);
    useEffect(() => {
      console.warn(`${moment().format("HH.mm.ss")} screen loaded"`);

      const interval = setInterval(() => {
        setNumber((prevNumber) => prevNumber + 1);
      }, waitTimeBetweenRadius);

      return () => clearInterval(interval);
    }, [number]);

    useEffect(() => {
      // When the component mounts or the route changes
      setIsCurrentScreen(true);

      // Clean up on unmount or route change
      return () => {
        setIsCurrentScreen(false);
      };
    }, [location]);

    const goBackToBookingFromNoDriver = () => {
      dispatch(setIsConfirmBooked(false));
    };

    const handleCancel = async () => {
      try {
        console.info(
          "CANCELLING THE CAB REQUEST SEARCH in payment option screen from the package iternary",
        );

        console.info(
          "fcm tokens======= in payment option screen",
          bidFcmTokens,
        );

        console.info(
          "bid phone numbers============== in payment option screen",
          bidPhoneNumbers,
        );

        console.log("bid.length in payment option screen", typeof bids);
        setWaitingStart(false);
        setStopSearch(true);
        localStorage.setItem("handleCancelCalled", "true");

        if (bids && Object.keys(bids).length > 0) {
          // Run the functions in parallel using Promise.all

          const [a, b, cabupdate] = await Promise.all([
            sendNotificationBidNotAccepted({
              cabRequestId,
              fcmTokens: bidFcmTokens,
              phoneNumbers: [bidPhoneNumbers],
            }),
            releaseRidersFromBidLock(bidPhoneNumbers),
            CabServices.update(cabRequestId, {
              isLock: true,
              status: "Cancel By User",
            }),
          ]);
          console.error("a, b, c===============", cabupdate);
          setHasCancelled(true);
          goBackToBookingFromNoDriver();
        } else {
          CabServices.update(cabRequestId, {
            isLock: true,
            status: "Cancel By User",
          });
          goBackToBookingFromNoDriver();
          setHasCancelled(true);
        }

        //   setModalVisible(false);
        // goBackToBooking();
      } catch (error) {
        console.error("Error in handleCancel:", error);
      }
    };

    useImperativeHandle(ref, () => ({
      handleCancel,
    }));
    const goBackToBooking = () => {
      // navigate("/");
    };

    useEffect(() => {
      // Update the currentTime state every second
      const timer = setInterval(() => {
        // const now = new Date().toISOString(); // Get the latest current time
        const now = new Date();
        const endTime = new Date(reviewEndTime);
        // const timeLeft = calculateRemainingTime(reviewEndTime, now);
        // console.log("timeLeft minutes", timeLeft);
        const timeLeft = calculateRemainingTime(endTime, now);
        console.log("timeLeft seconds", timeLeft);

        setRemainingTime(timeLeft);

        if (timeLeft <= 0 && !hasCancelled) {
          clearInterval(timer); // Clear the timer when countdown reaches zero
          if (isCurrentScreen) {
            handleCancel(); // Execute the action if the screen is active
            // dispatch(setIsConfirmBooked(false));
          }
        }
      }, 1000);

      return () => clearInterval(timer); // Cleanup interval on component unmount
    }, [reviewEndTime, isCurrentScreen]);

    const handlePlaceChange = (ref, type) => {
      if (ref.current) {
        const places = ref.current.getPlaces();
        if (places && places.length > 0) {
          const place = places[0];
          const location = place.geometry.location;

          const updatedLocation = {
            latitude: location.lat(),
            longitude: location.lng(),
            title: place.name || place.formatted_address,
            subtext: place.formatted_address,
            place_id: place.place_id,
          };

          // if (type === "pickup") {
          dispatch(setPickupLocation(updatedLocation));
          console.log("updatedLocation", updatedLocation);
          // } else if (type === "drop") {
          //   setDropLocation(updatedLocation);
          // }
        }
      }
    };

    /////test

    const validateForm = () => {
      let newErrors = {};

      // if (!formData.date) newErrors.date = "Please select a date";
      // if (!formData.time) newErrors.time = "Please select a time";
      if (!selectedDate) newErrors.date = "Please select a date";
      if (!selectedTime) newErrors.time = "Please select a time";
      if (!pickupLocation.title)
        newErrors.pickup = "Pickup location is required";
      // if (!dropLocation.title) newErrors.drop = "Drop location is required";
      if (personsCount <= 0)
        newErrors.personsCount = "Select at least 1 person";
      if (timeError) newErrors.time = timeError;

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Returns true if no errors
    };

    const handleConfirmBooking = () => {
      setShowErrors(true); // Show errors when clicking button
      setStopSearch(false);
      if (validateForm() && isLoggedIn) {
        createCabRequest();
        // setIsConfirmBooked(true);
        dispatch(setIsConfirmBooked(true));
        // console.log("setIsConfirmBooked", isConfirmBooked);
      }
      console.log("validateForm", validateForm());
    };
    console.log("stopSearch", stopSearch);
    console.log("notifiedRiders", notifiedRiders.length);

    // const createCabRequest = async () => {
    //   // Check if the user is logged in
    //   const isLoggedIn = localStorage.getItem("isLoggedIn");
    //   const token = localStorage.getItem("token");
    //   // toggleAuthModal();
    //   if (!LoggedInState || !token) {
    //     alert("You must be logged in to create a cab request.");
    //     // toggleAuthModal();
    //     return;
    //   }

    //   setSearchRadius(initialRadius);
    //   setIsCreatingSR(true);
    //   setFilteredRiders([]);
    //   setBidFcmTokens([]);
    //   setBidPhoneNumbers([]);
    //   setBids([]);
    //   dispatch(setIsConfirmBooked(true));

    //   // if (!formData.date || !formData.time) {
    //   //   alert("Please select a date and time.");
    //   //   return;
    //   // }

    //   // console.log("combinedDateTime",combinedDateTime)
    //   // console.log("formattedDateTime",formattedDateTime)
    //   const payload = {
    //     serviceType: serviceAssociated,
    //     requestedBy: "cruze",
    //     pickup_location: pickupLocation,
    //     drop_location: dropLocation,
    //     distance: 1,
    //     duration: 30,
    //     isTourPackage: true,
    //     tripDate: formattedDate,
    //     tripTime: formattedTime,
    //     numberOfPersons: personsCount,
    //     packageId: id,
    //     requestedCruze: "CAR",
    //     maxBid: bidCountToStopSearch,
    //     acType: acType,
    //   };

    //   try {
    //     const response = await CabServices.create(payload);

    //     console.log("Cab REQUEST payload:", payload);

    //     if (response && response?.cabRequest?.id) {
    //       setCabRequestId(response?.cabRequest?.id);
    //       getPossiblePartners(response?.cabRequest?.id, maxRadius);

    //       console.log(
    //         "Cab request created successfully. ID:",
    //         response?.cabRequest?.id
    //       );
    //     } else {
    //       console.error("Unexpected response format or missing ID:", response);
    //     }
    //   } catch (error) {
    //     console.error(
    //       "Error occurred during service request creation:",
    //       error.message
    //     );
    //     console.error("Full error details:", error);
    //   } finally {
    //     setIsCreatingSR(false);
    //   }
    // };

    const createCabRequest = async () => {
      // Check if the user is logged in
      const isLoggedIn = localStorage.getItem("isLoggedIn");
      const token = localStorage.getItem("token");
      // toggleAuthModal();
      if (!LoggedInState || !token) {
        alert("You must be logged in to create a cab request.");
        // toggleAuthModal();
        return;
      }

      setSearchRadius(initialRadius);
      setIsCreatingSR(true);
      setFilteredRiders([]);
      setBidFcmTokens([]);
      setBidPhoneNumbers([]);
      setBids([]);
      dispatch(setIsConfirmBooked(true));

      // if (!formData.date || !formData.time) {
      //   alert("Please select a date and time.");
      //   return;
      // }

      // console.log("combinedDateTime",combinedDateTime)
      // console.log("formattedDateTime",formattedDateTime)
      const payload = {
        serviceType: serviceAssociated,
        requestedBy: "cruze",
        pickup_location: pickupLocation,
        drop_location: dropLocation,
        distance: 1,
        duration: 30,
        isTourPackage: true,
        tripDate: formattedDate,
        tripTime: formattedTime,
        numberOfPersons: personsCount,
        packageId: id,
        requestedCruze: "CAR",
        maxBid: bidCountToStopSearch,
        acType: acType,
      };

      try {
        const response = await CabServices.create(payload);

        console.log("Cab REQUEST payload:", payload);

        if (response && response?.cabRequest?.id) {
          setCabRequestId(response?.cabRequest?.id);
          getPossiblePartners(response?.cabRequest?.id, maxRadius);

          console.log(
            "Cab request created successfully. ID:",
            response?.cabRequest?.id,
          );
        } else {
          console.error("Unexpected response format or missing ID:", response);
        }
      } catch (error) {
        console.error(
          "Error occurred during service request creation:",
          error.message,
        );
        console.error("Full error details:", error);
      } finally {
        setIsCreatingSR(false);
      }
    };

    const updateCabRequest = async (cabRequestId) => {
      const currentTime = new Date();

      // If lastUpdateTime is null (first update), the condition will fail
      // and the update will proceed.
      // if (lastUpdateTime && currentTime - lastUpdateTime < 180000) {
      if (
        lastUpdateTimeRef.current &&
        currentTime - lastUpdateTimeRef.current <
          waitTimeAfterSearchComplete * 1000
      ) {
        console.log(
          "Update skipped. Less than 3 minutes have passed since the last update.",
        );
        return; // Skip updating if the interval hasn't passed
      }

      // const interval = 180000;  // Interval in milliseconds (3 minutes)
      const interval = waitTimeAfterSearchComplete * 1000; // Interval in milliseconds (3 minutes)
      const newTime = new Date(currentTime.getTime() + interval);
      const newCurrentTime = new Date(currentTime.getTime());
      console.log("################ current start time ", newCurrentTime);
      console.log("################ review end time ", newTime);

      setCurrentTime(newCurrentTime);
      setReviewEndTime(newTime);

      const payload = {
        time: newTime,
        interval,
        status: "Review", // Set status to 'review'
      };

      try {
        const response = await CabServices.update(cabRequestId, payload);

        console.warn(
          "+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++",
          response,
        );

        if (response.success) {
          lastUpdateTimeRef.current = currentTime; // Update the last update time
          console.log("CabRequest updated successfully");
          // dispatch(setIsConfirmBooked(false));
        } else {
          console.error("Failed to update CabRequest:", response.message);
        }
      } catch (error) {
        console.error("Error updating CabRequest:", error);
      }
    };

    useEffect(() => {
      if (isCurrentScreen && bids.length > 0 && isConfirmBooked) {
        console.error("in the updateCabRequest bid length >0", cabRequestId);
        updateCabRequest(cabRequestId); // Update CabRequest when the timer starts
      }
      console.log(
        "isCurrentScreen, bids, isConfirmBooked, waitingStart",
        isCurrentScreen,
        waitingStart,
        isConfirmBooked,
      );
      if (isCurrentScreen && waitingStart && isConfirmBooked) {
        console.log(
          "in the updateCabRequest waitingStart = true",
          cabRequestId,
        );
        updateCabRequest(cabRequestId); // Update CabRequest when waiting starts
      }
    }, [isCurrentScreen, bids, isConfirmBooked, waitingStart]);

    const handleSelectCruze = (selectedIds) => {
      // Set the selected IDs in state
      setSelectedCruzeIds(selectedIds);

      // Add a condition to handle null or undefined
      if (!Array.isArray(selectedIds) || selectedIds.length === 0) {
        console.log("No Cruzes selected.  ");
        return;
      }

      // console.log('Selected Cruzes:');

      // selectedIds.forEach((id, index) => {
      //   console.log(`${index + 1}. Cruze Id: ${id}`);
      // });

      console.log(`Total Selected Cruzes: ${selectedIds.length}`);
      // console.log(`ALL: ${selectedIds}`);
    };

    const getPossiblePartners = async (cabRequestId, searchRadius) => {
      console.log("Fetching the nearest riders for cab Id ", cabRequestId);

      if (!cabRequestId) {
        console.error("Invalid cabRequestId");
        return;
      }

      setIsFetchingRiders(true);
      setRidersFound(true);

      try {
        // const riders = await TourPackageServices.PartnersNearby({
        //   user_coords: {
        //     latitude: pickupLocation?.latitude,
        //     longitude: pickupLocation?.longitude,
        //   },
        //   // radius: searchRadius,
        //   serviceAssociated: serviceAssociated,
        //   cruzeIds: selectedCruzeIds
        // });

        const riders = await TourPackageServices.PartnersNearby({
          // user_coords: {
          //   // latitude: pickupLocation?.latitude,
          //   // longitude: pickupLocation?.longitude,
          //   latitude: pickupLocation.latitude,
          //   longitude: pickupLocation.longitude,
          // },
          // // radius: searchRadius,
          // serviceAssociated: serviceAssociated,
          // cruzeIds: selectedCruzeIds,
          // // selectedDate: formData.date,
          // selectedDate: selectedDate,

          user_coords: {
            latitude: pickupLocation?.latitude,
            longitude: pickupLocation?.longitude,
          },
          // radius: searchRadius,
          serviceAssociated: serviceAssociated,
          serviceType: serviceAssociated,
          cruzeIds: selectedCruzeIds,
          selectedDate: selectedDate,
          selectedTime: selectedTime,
          cityId: CITY_ID,
          tourPackageId: selectedPackageDetails?._id,
          // isAc: route?.params?.acType == "AC" ? true : false,
          isAc: acType == "AC" ? true : false,
          cabRequestId,
          // isAutoBid: route?.params?.selectedPackage?.biddingConfiguration?.isAutoBid == true ? true : false,
          isAutoBid:
            selectedPackageDetails?.biddingConfiguration?.isAutoBid == true
              ? true
              : false,
          pickupLocation: pickupLocation,
          dropLocation: dropLocation,
        });

        console.log("Nearest drivers:", riders);
        console.log("Nearest drivers count:", riders?.length);

        //TODAY COMMENT
        // setRidersFound(true)
        // setPartnersList(dummyOnlineRiders)

        // setBids(dummyData)

        //TODAY UNCOMMENT
        if (riders?.riders?.length > 0) {
          // if (riders?.riders?.filteredRiders?.length > 0) {

          setRidersFound(true);
          setPartnersList(riders?.riders);
          // setPartnersList(riders?.riders?.filteredRiders);

          // filterByRadiusAndNotify(cabRequestId)

          // setSearching(true);
          setSearching(true);
          setSearchingInProgress(true);
        } else {
          console.warn("No riders found nearby");
          setPartnersList([]);
          setRidersFound(false);
        }
      } catch (err) {
        console.error("Server error:", err);
      } finally {
        setIsFetchingRiders(false);
      }
    };

    useEffect(() => {
      console.log(
        `${moment().format("HH.mm.ss")} Executing filterByRadiusAndNotify()`,
      );

      try {
        // Check if cabRequestId and partnersList are valid
        if (!cabRequestId) {
          console.log("cabRequestId is missing - so not checking bidlist.");
          return;
        }

        if (!partnersList || partnersList.length === 0) {
          console.log(
            "partnersList is empty or undefined - skipping bid check.",
          );
          return;
        }

        if (!stopSearch) {
          filterByRadiusAndNotify(cabRequestId);
        }
      } catch (error) {
        console.error("An error occurred in useEffect:", error);
      }
    }, [number, partnersList]);

    useEffect(() => {
      const isLoggedIn = localStorage.getItem("isLoggedIn");
      console.log("isLoggedIn", isLoggedIn);
      if (!isLoggedIn) {
        console.log("in if part", isLoggedIn);
        toggleAuthModal();
        setIsLoggedIn(false);
      }
    }, [LoggedInState]);

    useEffect(() => {
      // Check if user just logged in and there's saved booking data
      if (LoggedInState && !isConfirmBooked) {
        const savedBookingData = localStorage.getItem("pendingBookingData");

        if (savedBookingData) {
          try {
            const bookingData = JSON.parse(savedBookingData);

            // Restore all form data
            setSelectedDate(bookingData.selectedDate);
            setSelectedTime(bookingData.selectedTime);
            dispatch(setPickupLocation(bookingData.pickupLocation));
            setPersonsCount(bookingData.personsCount);
            setSelectedCruzeIds(bookingData.selectedCruzeIds);
            setAcType(bookingData.acType);

            // Clear the saved data
            localStorage.removeItem("pendingBookingData");

            // Auto-submit the booking after a short delay to ensure state is updated
            setTimeout(() => {
              setIsCabrequestCancelled(true);
              handleConfirmBooking();
            }, 100);
          } catch (error) {
            console.error("Error restoring booking data:", error);
            localStorage.removeItem("pendingBookingData");
          }
        }
      }
    }, [LoggedInState]);

    const handleMapCenterChange = () => {
      const lat = mapCenter.lat;
      const lng = mapCenter.lng;

      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.results.length > 0) {
            const address = data.results[0].formatted_address;

            // if (activeType === "pickup") {
            setPickupLocation((prev) => ({
              ...prev,
              latitude: lat,
              longitude: lng,
              title: address,
              subtext: address,
            }));
            // } else if (activeType === "drop") {
            setDropLocation((prev) => ({
              ...prev,
              latitude: lat,
              longitude: lng,
              title: address,
              subtext: address,
            }));
            // }
          }
        });
    };

    const filterByRadiusAndNotify = async (cabRequestId) => {
      try {
        const nextMinRadius = searchRadius;
        const nextMaxRadius = searchRadius + incrementByRadius;

        console.info(
          `Searching for riders between ${nextMinRadius} KM and ${nextMaxRadius} KM radius...`,
        );

        let newFilteredRiders = [];
        try {
          newFilteredRiders = filterRidersByRadius(
            partnersList,
            pickupLocation,
            nextMinRadius,
            nextMaxRadius,
          );
        } catch (error) {
          console.error("Error filtering riders by radius:", error);
          return;
        }

        if (!newFilteredRiders || newFilteredRiders.length === 0) {
          console.warn(
            `No riders found between ${nextMinRadius} KM and ${nextMaxRadius} KM radius.`,
          );

          setNumber((prevNumber) => prevNumber + 1);
          setNumber(parseInt(number) + 1);
        } else {
          console.info(
            `Found ${newFilteredRiders.length} riders in the radius range ${nextMinRadius} KM to ${nextMaxRadius} KM.`,
          );

          try {
            // Get riders who haven't been notified yet
            const newNotifiedRiders = newFilteredRiders.filter(
              (rider) => !notifiedRiders.includes(rider.id),
            );
            console.log("newNotifiedRiders", newFilteredRiders);
            // Send notification to new riders
            if (newNotifiedRiders.length > 0) {
              notifyRiders(cabRequestId, newNotifiedRiders);

              setNotifiedRiders((prev) => [
                ...prev,
                ...newNotifiedRiders.map((r) => r.id),
              ]);
            }

            // Generate random rotation for each rider and set the filtered riders state
            const ridersWithRotation = newFilteredRiders.map((rider) => ({
              ...rider,
              rotation: Math.floor(Math.random() * 360), // Random rotation between 0 and 360
            }));

            setFilteredRiders((prev) => [...prev, ...ridersWithRotation]);
          } catch (error) {
            console.error("Error processing and notifying riders:", error);
            return;
          }
        }

        try {
          const conditionMet = checkCondition();
          console.log("conditionMet", conditionMet);
          // setWaitingStart(true);
          if (conditionMet || nextMaxRadius >= maxRadius) {
            console.info(
              `Condition satisfied or reached the maximum search radius of ${maxRadius} KM. Stopping search.`,
            );
            setWaitingStart(true);
            setSearching(false);
            setSearchingInProgress(false);
            setStopSearch(true);

            return;
          }
        } catch (error) {
          console.error("Error checking condition:", error);
          return;
        }

        // Update the radius for the next iteration
        setSearchRadius(nextMaxRadius);
      } catch (error) {
        console.error("Unexpected error in filterByRadiusAndNotify:", error);
      }
    };

    function filterRidersByRadius(
      riders,
      pickupLocation,
      minRadius,
      maxRadius,
    ) {
      try {
        // Ensure riders is a valid array
        if (!Array.isArray(riders) || riders.length === 0) {
          console.warn("Riders data is invalid or empty. Skipping filtering.");
          return [];
        }

        // Ensure pickupLocation is valid
        if (
          !pickupLocation ||
          !Number.isFinite(pickupLocation.latitude) ||
          !Number.isFinite(pickupLocation.longitude)
        ) {
          console.warn("Pickup location is invalid. Skipping filtering.");
          return [];
        }

        return riders.filter((rider) => {
          try {
            const riderLat = rider.current_location?.latitude;
            const riderLon = rider.current_location?.longitude;
            const pickupLat = pickupLocation?.latitude;
            const pickupLon = pickupLocation?.longitude;

            // Check if coordinates are valid numbers
            if (
              !Number.isFinite(riderLat) ||
              !Number.isFinite(riderLon) ||
              !Number.isFinite(pickupLat) ||
              !Number.isFinite(pickupLon)
            ) {
              console.warn(
                `Skipping rider with invalid coordinates: riderLat=${riderLat}, riderLon=${riderLon}, pickupLat=${pickupLat}, pickupLon=${pickupLon}`,
              );
              return false; // Skip invalid entries
            }

            // Calculate the distance
            const distance = parseFloat(
              getDistanceBetweenCoordinates(
                pickupLat,
                pickupLon,
                riderLat,
                riderLon,
              ),
            );

            // Log the distance for each rider
            console.log(
              `Checking between ${minRadius} and ${maxRadius}. Rider '${rider?.first_name}' is ${distance} KM away.`,
            );

            // Filter riders within the given radius range
            return distance >= minRadius && distance <= maxRadius;
          } catch (error) {
            console.error("Error while filtering a rider:", error);
            return false;
          }
        });
      } catch (error) {
        console.error("Unexpected error in filterRidersByRadius:", error);
        return [];
      }
    }

    async function notifyRiders(cabRequestId, riders) {
      try {
        console.log(
          `Notifying riders: ${riders.map((r) => r.id)} - ${riders.map(
            (r) => r.first_name,
          )} - ${riders.map((r) => r.phone_number)}- found within ${
            searchRadius + incrementByRadius
          } kilometer`,
        );
        console.log(`notifyRiders ->  cabRequestId`, cabRequestId);

        // Ensure riders is a valid array
        if (Array.isArray(riders) && riders.length > 0) {
          try {
            console.log(`Generating FCM Tokens and Phone numbers.`);

            const fcm_tokens = riders
              .map((rider) => rider.fcm_token)
              .filter((token) => token);
            const phoneNumbers = riders
              .map((rider) => rider.phone_number)
              .filter((number) => number);

            console.log(
              `Generating FCM Tokens and Phone numbers Done. fcm_tokens `,
              fcm_tokens,
            );
            console.log(
              `Generating FCM Tokens and Phone numbers Done. phoneNumbers `,
              phoneNumbers,
            );

            if (fcm_tokens.length > 0) {
              try {
                console.log(`Yes FCM length is more than 0`);

                // sendNotificationToPartners(cabRequestId, fcm_tokens, phoneNumbers, notificationType);
                setIsSendingNotifications(true);

                await sendNotificationBidRequest({
                  cabRequestId: cabRequestId,
                  fcmTokens: fcm_tokens,
                  phoneNumbers: phoneNumbers,
                  authUser: user,
                  selectedPackage: selectedPackageDetails,
                  acType: acType,
                  // selectedDate: formData.date,
                  // selectedTime: formData.time,
                  selectedDate: formattedDate,
                  selectedTime: formattedTime,
                  pickupLocation,
                  serviceAssociated,
                  setIsSendingNotifications,
                });
              } catch (error) {
                console.error(
                  "Error while sending notifications to partners:",
                  error,
                );
              } finally {
                setIsSendingNotifications(false);
              }
            } else {
              console.warn("No valid FCM tokens found for riders");
            }
          } catch (error) {
            console.error("Error while processing FCM tokens:", error);
          }
        } else {
          console.warn(
            "Riders array is empty or invalid, skipping notifications.",
          );
        }
      } catch (error) {
        console.error("Unexpected error in notifyRiders:", error);
      }
    }

    function checkCondition() {
      try {
        // Ensure bids is a valid array
        console.log("bids.length ", bids.length);
        if (Array.isArray(bids)) {
          return bids.length >= bidCountToStopSearch;
        } else {
          // console.warn("Bids is not a valid array.");
          return false; // Return false if bids is not a valid array
        }
      } catch (error) {
        console.error("Unexpected error in checkCondition:", error);
        return false; // Return false in case of an error
      }
    }

    const getMessage = () => {
      if (isCreatingSR) return "Initializing your request...";
      if (isFetchingRiders) return "Looking for available partners...";
      if (isSendingNotifications)
        return "Waiting for the drivers to share their fare amount...";
      return "Loading your preferences";
    };

    const handleAcceptedBid = async (
      bid,
      riderId,
      acceptedToken,
      bidPhoneNumbers1,
    ) => {
      // Get the navigate function

      try {
        setCreatingTrip(true);
        setStopSearch(true);

        const bidNotAcceptedTokens = bidFcmTokens.filter(
          (token) => token !== acceptedToken,
        );
        const bidNotPhoneNumber = bidPhoneNumbers.filter(
          (token) => token !== bidPhoneNumbers1,
        );

        const payload = {
          serviceAssociated,
          selectedPackage: selectedPackageDetails,
          selectedDate: formattedDate,
          selectedTime: formattedTime,
          isFutureDateSelected,
          personsCount,
          selectedCruzeIds,
          pickupLocation,
          bid,
          riderId,
          bidFcmTokens,
          acceptedToken,
          bidPhoneNumbers: bidPhoneNumbers1,
        };

        // Execute API calls in parallel
        await Promise.all([
          sendNotificationBidNotAccepted({
            cabRequestId,
            fcmTokens: bidNotAcceptedTokens,
            phoneNumbers: bidNotPhoneNumber,
          }),
          releaseRidersFromBidLock(bidNotPhoneNumber),
        ]);

        console.log("Navigating to Booking Summary...");

        // Navigate to the booking summary page and pass payload via state
        navigate("/booking-summary", {
          state: { ...payload, cabRequestId },
        });
        // navigate('/booking-summary', { state: payload });
      } catch (error) {
        console.error("Error handling accepted bid:", error);
      } finally {
        setCreatingTrip(false);
      }
    };

    const renderBiddingList = useMemo(() => {
      return (
        <>
          <BiddingList
            data={bids}
            onBidAccepted={handleAcceptedBid}
            isCreatingTrip={isCreatingTrip}
          />
        </>
      );
    }, [bids?.length, isCreatingTrip]);

    const renderContent = () => {
      return (
        <div className="flex-1 bg-gray-100 p-2">
          {/* Message Display */}
          {(isCreatingSR || isFetchingRiders || isSendingNotifications) && (
            <p className="text-lg font-medium text-center my-4">
              {getMessage()}
            </p>
          )}

          {/* Loader when searching for drivers */}
          {searchingInProgress && bids && bids.length === 0 ? (
            <div className="text-center my-8">
              <p className="text-lg font-medium text-gray-700 mb-2">
                Please wait while we are searching for the drivers...
              </p>
              <p className="text-sm text-gray-600 italic mt-2">
                {engagingMessages[engagementMsgIndex]}
              </p>
              <div className="flex justify-center mt-4">
                <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
            </div>
          ) : waitingStart && bids?.length === 0 ? (
            <div className="text-center my-8">
              <p className="text-lg font-medium text-gray-700">
                Please wait while our driver reviews your request and bids.
              </p>
              <p className="text-sm text-gray-600 italic mt-2">
                {waitingMessages[waitingMsgIndex]}
              </p>
            </div>
          ) : (
            <div
              className="bg-white  rounded-lg shadow-lg p-4"
              style={{ height: snapTo[1] }}
            >
              {/* Bidding List Rendering */}
              {renderBiddingList}
            </div>
          )}
        </div>
      );
    };

    const renderButtons = useMemo(() => {
      // console.error("searchingInProgress===================",searchingInProgress)
      return (
        <div className="flex justify-center items-center gap-4 mt-6 min-h-full">
          {searchingInProgress && isCabrequestCancelled ? (
            <>
              {/* Cancel Button */}
              <button
                onClick={() => {
                  setModalCancelVisible(true);
                  setIsOpen(false);
                }}
                className="bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600 transition"
              >
                Cancel
              </button>

              {/* Searching Button */}
              <button
                disabled
                className="bg-black text-gray-300 py-2 px-4 rounded-lg cursor-not-allowed"
              >
                Searching in {searchRadius} km
              </button>
            </>
          ) : (
            <>
              {console.log("waitingStart", waitingStart)}
              {waitingStart && (
                <>
                  {/* Cancel Button */}
                  <button
                    // onClick={() => setModalVisible(true)}
                    onClick={() => {
                      setModalCancelVisible(true);
                      setIsOpen(false);
                    }}
                    className="bg-white text-red py-2 px-4 rounded-lg hover:bg-red-600 transition"
                  >
                    Cancel
                  </button>

                  {/* Bidding/Waiting Button */}
                  <div
                    className={`flex items-center gap-3 px-4 py-2 rounded-lg ${
                      bids?.length > 0
                        ? "bg-green-200 hover:bg-green-400"
                        : "bg-yellow-500 hover:bg-yellow-600"
                    } transition`}
                  >
                    <span className="text-green-700 font-medium">
                      {bids?.length > 0 ? "Review Bids" : "Wait for the bid"}
                    </span>

                    {/* Countdown Timer */}
                    <CountdownCircleTimer
                      isPlaying={true}
                      duration={waitTimeAfterSearchComplete}
                      colors={["#008000", "#F7B801", "#A30000"]}
                      colorsTime={[
                        waitTimeAfterSearchComplete * 0.66,
                        waitTimeAfterSearchComplete * 0.33,
                        0,
                      ]}
                      size={30}
                      strokeWidth={3}
                      strokeLinecap="butt"
                      // onComplete={() => {
                      //   handleCancel(); // Call your cancel function here
                      //   return { shouldRepeat: false }; // Do not repeat
                      // }}
                    >
                      {({ remainingTime }) => {
                        const minutes = Math.floor(remainingTime / 60);
                        const seconds = remainingTime % 60;

                        return (
                          <span className="text-gray text-sm">
                            {`${minutes}:${
                              seconds < 10 ? `0${seconds}` : seconds
                            }`}
                          </span>
                        );
                      }}
                    </CountdownCircleTimer>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      );
    }, [
      searchingInProgress,
      waitingStart,
      bids,
      remainingTime,
      waitTimeAfterSearchComplete,
      isCabrequestCancelled,
    ]);

    useEffect(() => {
      const fetchBids = async () => {
        try {
          // console.info("BIDS LENGTH IN fetchBids ", bids.length);

          if (!cabRequestId) {
            console.log("cabRequestId is missing - so not checking bid list.");
            return;
          }

          if (!partnersList || partnersList.length === 0) {
            console.log(
              "partnersList is empty or undefined - skipping bid check.",
            );
            return;
          }

          console.log("Triggered bidding call");
          const res = await BidServices.filterWithCabRequest({
            cab_request: cabRequestId,
          });

          if (!res || !res.bids) {
            console.warn("No bids returned by the service.");
            return;
          }

          setBids((prevBids) => {
            const newBids = res.bids.filter(
              (bid) => !prevBids.some((prevBid) => prevBid.id === bid.id),
            );

            if (newBids.length > 0) {
              console.log(`New bids received: ${newBids.length}`);
              setWaitingStart(true);
              // playNotificationSound(); // Play sound for new bids
            } else {
              console.log("No new bids received.");
            }

            return [...prevBids, ...newBids];
          });

          // Update bid FCM tokens
          setBidFcmTokens((prevTokens) => {
            const newTokens = res.bids
              .map((bid) => bid.rider?.fcm_token) // Extract fcm_token
              .filter((token) => token); // Remove null or undefined

            return Array.from(new Set([...prevTokens, ...newTokens]));
          });

          setBidPhoneNumbers((prevNumber) => {
            const newNumbers = res.bids
              .map((bid) => bid.rider?.phone_number)
              .filter((number) => number);

            return Array.from(new Set([...prevNumber, ...newNumbers]));
          });
        } catch (error) {
          console.error("Error fetching bids:", error);
        }
      };

      const interval = setInterval(fetchBids, 10000);

      // const interval = setInterval(() => {
      //   if (bids.length < 5) {
      //     fetchBids();
      //   } else {
      //     console.info('Stopping fetchBids as bids.length has reached 5.');
      //     clearInterval(interval);
      //   }
      // }, 10000);

      return () => {
        clearInterval(interval);
      };
      // }, [cabRequestId, partnersList, bids.length]);
    }, [cabRequestId, partnersList, waitingStart]);

    const getMinDate = () => {
      const today = new Date();
      const hours = today.getHours();

      if (hours >= 10) {
        // If time is past 10 AM, disable today
        today.setDate(today.getDate() + 1);
      }

      return today.toISOString().split("T")[0]; // Format YYYY-MM-DD
    };
    const getMaxDate = () => {
      const today = new Date();
      today.setDate(today.getDate() + 7); // Add 7 days
      return today.toISOString().split("T")[0];
    };

    const toggleAuthModal = () => {
      setIsAuthOpen(!isAuthOpen);
      // if (!LoggedInState) {
      //   setShowForm(false);
      // }
    };

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
      };
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    // const handleTimeChange = (e) => {
    //   const selected = e.target.value;
    //   const minTime = "07:00";
    //   const maxTime = "10:00";

    //   if (selected >= minTime && selected <= maxTime) {
    //     setSelectedTime(selected);
    //     setTimeError(""); // Clear the error message when valid
    //   } else {
    //     setTimeError("Please select a time between 7:00 AM and 10:00 AM.");

    //     setSelectedTime(selected); // Reset the time to empty or previous valid value
    //   }
    // };

    // const handleTimeChange = (e) => {
    //   const selected = e.target.value;  // Time selected by the user
    //   const bookBeforeTime = selectedPackageDetails?.bookBeforeTime;  // e.g., "2024-12-07T08:00:00.000Z"

    //   if (!bookBeforeTime) {
    //     console.error("Book before time is not available.");
    //     return;
    //   }

    //   // ✅ Convert bookBeforeTime to local time format (HH:mm)
    //   const bookTime = new Date(bookBeforeTime);
    //   const bookHours = bookTime.getHours().toString().padStart(2, "0");
    //   const bookMinutes = bookTime.getMinutes().toString().padStart(2, "0");
    //   const maxTime = `${bookHours}:${bookMinutes}`;  // e.g., "08:00"

    //   const minTime = "07:00";  // Static min time

    //   console.log(`Min Time: ${minTime}, Max Time: ${maxTime}`);  // For debugging

    //   // ✅ Validate selected time within the range of minTime and maxTime
    //   if (selected >= minTime && selected <= maxTime) {
    //     setSelectedTime(selected);
    //     setTimeError("");  // Clear error message when valid
    //   } else {
    //     setTimeError(`Please select a time between ${minTime} and ${maxTime}.`);
    //     setSelectedTime(selected);  // Reset the time
    //   }
    // };

    const handleTimeChange = (e) => {
      const selected = e.target.value; // Time selected by the user
      const bookBeforeTime = selectedPackageDetails?.bookBeforeTime; // e.g., "2024-12-07T08:00:00.000Z"
      const selectedDateObj = new Date(selectedDate); // The date selected by the user
      const today = new Date();

      if (!bookBeforeTime) {
        console.error("Book before time is not available.");
        return;
      }

      // ✅ Convert bookBeforeTime to local time format (HH:mm)
      const bookTime = new Date(bookBeforeTime);
      const bookHours = bookTime.getHours().toString().padStart(2, "0");
      const bookMinutes = bookTime.getMinutes().toString().padStart(2, "0");
      const maxTime = `${bookHours}:${bookMinutes}`; // e.g., "08:00"

      // ✅ Set minTime dynamically:
      let minTime;
      if (
        selectedDateObj.toDateString() === today.toDateString() // If booking is for today
      ) {
        const currentHours = today.getHours().toString().padStart(2, "0");
        const currentMinutes = today.getMinutes().toString().padStart(2, "0");
        minTime = `${currentHours}:${currentMinutes}`; // e.g., current time
      } else {
        minTime = "07:00"; // Static min time for future dates
      }

      console.log(`Min Time: ${minTime}, Max Time: ${maxTime}`); // For debugging

      // ✅ Validate selected time within the range of minTime and maxTime
      if (selected >= minTime && selected <= maxTime) {
        setSelectedTime(selected);
        setTimeError(""); // Clear error message when valid
      } else {
        setTimeError(`Please select a time between ${minTime} and ${maxTime}.`);
        setSelectedTime(selected); // Reset the time
      }
    };

    if (loading) {
      return (
        <div className="flex flex-col items-center justify-center">
          <div className="loader border-t-4 border-blue-500 rounded-full w-12 h-12 animate-spin"></div>
          <p className="mt-4 text-gray-700">Loading...</p>
        </div>
      );
    }

    const handleDateChange = (e) => {
      const inputDate = e.target.value;

      console.log("inputDate", inputDate);
      // Only validate when the full date is entered (YYYY-MM-DD → length = 10)
      if (inputDate.length === 10) {
        if (inputDate < getTodayDate() || inputDate > getMaxDate()) {
          console.log("Please select a valid date within the range.");
          // setSelectedDate(""); // Reset invalid date
        } else {
          setSelectedDate(inputDate);
        }
      } else {
        // Store partial date while typing
        setSelectedDate(inputDate);
      }
    };

    const generateTimeSlots = () => {
      const times = ["Now"];
      let hour = 0;
      let minute = 0;

      while (hour < 24) {
        const ampm = hour < 12 ? "AM" : "PM";
        const displayHour = hour % 12 === 0 ? 12 : hour % 12;

        times.push(
          `${displayHour}:${minute.toString().padStart(2, "0")} ${ampm}`,
        );

        minute += 10;
        if (minute >= 60) {
          minute = 0;
          hour++;
        }
      }

      return times;
    };

    const timeSlots = generateTimeSlots();

    const handlePrepaidOfferClick = () => {
      if (!LoggedInState) {
        // Save all form data to localStorage before opening auth modal
        const bookingData = {
          selectedDate,
          selectedTime,
          pickupLocation,
          personsCount,
          selectedCruzeIds,
          acType,
        };

        localStorage.setItem("pendingBookingData", JSON.stringify(bookingData));

        // Close the bottom sheet and open AuthModal if not logged in
        setIsOpen(false);
        toggleAuthModal();
      } else {
        // Proceed with booking
        setIsCabrequestCancelled(true);
        handleConfirmBooking();
      }
    };

    const handleBackConfirmation = (confirmed) => {
      setModalCancelVisible(false);

      if (confirmed) {
        handleCancel();
        dispatch(setIsConfirmBooked(false));
        setNotifiedRiders([]);
        setSearching(false);

        setIsBackConfirmed(true); // ✅ Set back confirmation flag
        // navigate(-1);               // Go back
      }
      // console.log("setIsConfirmBooked", isConfirmBooked);
    };

    console.log(
      "isCabrequestCancelled",
      searchingInProgress && isCabrequestCancelled,
    );
    // const bookBeforeTime = "2024-12-07T08:00:00.000Z"; // Use only time part

    return (
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg ">
        {/* Floating "Book Your Tour" Button for Mobile */}
        {isMobile && (
          <>
            {selectedPackageDetails.isBookingLocked === true ? (
              <div className="fixed bottom-0 left-0 w-full z-50">
                <button
                  className="w-full py-3 bg-black text-white rounded-t-lg shadow-lg hover:bg-gray-700 transition duration-300"
                  // onClick={() => {
                  //   setIsOpen(true);
                  //   setShowForm(true); // Ensure the form is visible in the bottom sheet
                  // }}
                >
                  Temporarily Not Available
                </button>
              </div>
            ) : (
              <>
                <div className="fixed bottom-0 left-0 w-full z-50">
                  <button
                    className="w-full py-3 bg-black text-white rounded-t-lg shadow-lg hover:bg-gray-700 transition duration-300"
                    onClick={() => {
                      setIsOpen(true);
                      setShowForm(true); // Ensure the form is visible in the bottom sheet
                    }}
                  >
                    Book Your Tour
                  </button>
                </div>
              </>
            )}
          </>
        )}

        {/* Desktop "Book Your Tour" Button */}
        {/* {!showForm && !isMobile && (
        <button
          className="w-full py-3 bg-black text-white rounded-lg shadow-md hover:bg-gray-700 transition duration-300"
          onClick={() => {
            setShowForm(true);
            // toggleAuthModal();
          }}
        >
          Book Your Tour
        </button>
      )} */}

        {/* Authentication Modal */}
        {/* {!LoggedInState ? (
       
      ) : ( */}
        <>
          {/* Booking Form */}
          <div className="flex-grow overflow-visible p-4">
            {!isConfirmBooked && !isMobile && (
              <div className="mt-2 p-4 border rounded-lg bg-white">
                {infoMessage && (
                  <p className="text-blue-600 text-sm mt-1">{infoMessage}</p>
                )}
                <h3 className="text-lg font-semibold mb-2">
                  Select Date & Time
                </h3>

                <div className="grid grid-cols-2 gap-4 mb-2">
                  {/* Date Input */}
                  <div>
                    <label className="text-sm font-semibold text-gray-700">
                      Date
                    </label>
                    <input
                      type="date"
                      name="date"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      // onChange={}
                      className="w-full p-2 border rounded"
                      // min={moment().format("YYYY-MM-DD")} // Prevent past dates
                      min={getTodayDate()}
                      max={getMaxDate()}
                      onKeyDown={(e) => e.preventDefault()}
                      onFocus={(e) => e.target.showPicker()}
                    />
                    {errors.date && (
                      <p className="text-red-500 text-sm">{errors.date}</p>
                    )}
                  </div>

                  {/* Time Input */}
                  {/* <div>
                  <label className="text-sm font-semibold text-gray-700">
                    Time
                  </label>
                  <input
                    type="time"
                    name="time"
                    value={selectedTime}
                    
                    onChange={handleTimeChange}
                    className="w-full p-2 border rounded"
                    onFocus={(e) => e.target.showPicker()}
                    
                  />
                  {errors.time && (
                    <p className="text-red-500 text-sm">{errors.time}</p>
                  )}
                  
                </div> */}

                  {/* <div>
                  <label className="text-sm font-semibold text-gray-700">
                    Time
                  </label>
                  <select
                    name="time"
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    className="w-full p-2 border rounded"
                  >
                    {timeSlots.map((time, index) => (
                      <option key={index} value={time}>
                        {time}
                      </option>
                    ))}
                  </select>

                  {errors.time && (
                    <p className="text-red-500 text-sm">{errors.time}</p>
                  )}
                </div> */}

                  <div>
                    <label className="text-sm font-semibold text-gray-700">
                      Time
                    </label>
                    <input
                      type="time"
                      name="time"
                      value={selectedTime}
                      onChange={handleTimeChange}
                      className="w-full p-2 border rounded"
                    />
                    {/* {errors.time && (
                    <p className="text-red-500 text-sm">{errors.time}</p>
                  )} */}
                    {timeError && (
                      <p className="text-red-500 text-sm mt-1">{timeError}</p>
                    )}
                  </div>
                </div>

                <input
                  type="text"
                  placeholder="Pickup Location"
                  value={pickupLocation.title}
                  readOnly
                  className="w-full p-2 border rounded mb-2 cursor-pointer"
                  onClick={() => {
                    setShowPickupMap(true);
                    setActiveType("pickup");
                  }}
                />
                {errors.pickup && (
                  <p className="text-red-500 text-sm">{errors.pickup}</p>
                )}

                {/* <input
             type="text"
             placeholder="Drop Location"
             value={dropLocation.title}
             readOnly
             className="w-full p-2 border rounded mb-2 cursor-pointer"
             onClick={() => {
               setShowDropMap(true);
               setActiveType("drop");
             }}
           />
           {errors.drop && (
             <p className="text-red-500 text-sm">{errors.drop}</p>
           )} */}
                {showPickupMap && (
                  <PickupMap
                    API_KEY={API_KEY}
                    pickupLocation={pickupLocation}
                    // setPickupLocation={setPickupLocation}
                    setShowPickupMap={setShowPickupMap}
                    polygonCoordinates={polygonCoordinates}
                    setIsOpen={setIsOpen}
                  />
                )}

                {/* <LoadScript googleMapsApiKey={API_KEY} libraries={["places"]}>
            
             {showDropMap && (
               <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                 <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-2/3">
                   <StandaloneSearchBox
                     onLoad={(ref) => (dropRef.current = ref)}
                     onPlacesChanged={() =>
                       handlePlaceChange(dropRef, "drop")
                     }
                   >
                     <input
                       type="text"
                       placeholder="Drop Location"
                       value={dropLocation.title}
                       onChange={(e) =>
                         setDropLocation((prev) => ({
                           ...prev,
                           title: e.target.value, 
                         }))
                       }
                       className="w-full p-2 border rounded mb-3 cursor-pointer"
                     />
                   </StandaloneSearchBox>

                   <h3 className="text-lg font-semibold mb-3">
                     Select drop Location
                   </h3>
                   <div className="relative">
                     <GoogleMap
                       mapContainerStyle={containerStyle}
                       center={mapCenter}
                       zoom={13}
                       onLoad={(map) => (dropMapRef.current = map)}
                       onIdle={handleMapCenterChange}
                       onDragEnd={() => {
                         if (dropMapRef.current) {
                           const newCenter = dropMapRef.current.getCenter();
                           const updatedCenter = {
                             lat: newCenter.lat(),
                             lng: newCenter.lng(),
                           };

                           setMapCenter(updatedCenter); // Update state
                           handleMapCenterChange(updatedCenter); // Fetch address
                         }
                       }}
                     />
                    
                     <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                       <img
                         src={Pin} 
                         alt="Marker"
                         className="w-10 h-10"
                       />
                     </div>
                   </div>

                   <button
                     className="w-full py-2 mt-3 bg-gray-600 text-white rounded-lg"
                     onClick={() => setShowDropMap(false)}
                   >
                     Close
                   </button>
                 </div>
               </div>
             )}
           </LoadScript> */}
                <ToggleButton
                  onSelect={(value) => setAcType(value)}
                  defaultValue={acType}
                />

                <PersonCount value={personsCount} onChange={setPersonsCount} />
                {errors.personsCount && (
                  <p className="text-red-500 text-sm">{errors.personsCount}</p>
                )}
                <CruzeTypes
                  capacity={personsCount}
                  onSelect={handleSelectCruze}
                  isAutoBid={
                    selectedPackageDetails?.biddingConfiguration?.isAutoBid
                  }
                />
                {selectedPackageDetails.isBookingLocked === true ? (
                  <button
                    className="w-full py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition duration-300"
                    // onClick={() => {
                    // onClick={handlePrepaidOfferClick}
                    // if (!isLoggedIn) {
                    //   // If user is not logged in, open authentication modal
                    //   setIsOpen(false);
                    //   toggleAuthModal(); // Open the authentication modal

                    // } else {
                    //   // Handle booking or further action when logged in
                    //   handleConfirmBooking();
                    // }
                    // }}
                    //  disabled={Object.values(errors).some(error => error !== '')}
                  >
                    Temporarily Not Available
                  </button>
                ) : (
                  <button
                    className="w-full py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition duration-300"
                    // onClick={() => {
                    onClick={handlePrepaidOfferClick}
                    // if (!isLoggedIn) {
                    //   // If user is not logged in, open authentication modal
                    //   setIsOpen(false);
                    //   toggleAuthModal(); // Open the authentication modal

                    // } else {
                    //   // Handle booking or further action when logged in
                    //   handleConfirmBooking();
                    // }
                    // }}
                    //  disabled={Object.values(errors).some(error => error !== '')}
                  >
                    Get Prepaid Offers
                  </button>
                )}

                <button
                  className="w-full py-2 mt-2 text-gray-600 underline"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
                {/* 
            <AuthModal
              isOpen={isAuthOpen}
              onClose={toggleAuthModal}
              onLoginSuccess={() => setIsLoggedIn(true)}
            /> */}
              </div>
            )}

            {ridersFound === false && isConfirmBooked && !isMobile ? (
              <>
                <div className="flex justify-center items-center min-h-[40vh]">
                  <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
                    <NoOnlineDrivers
                      goBackToBooking={() => goBackToBookingFromNoDriver()}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                {stopSearch &&
                notifiedRiders?.length === 0 &&
                !isMobile &&
                isConfirmBooked ? (
                  <>
                    <SearchStopped onClose={() => handleCancel()} />
                  </>
                ) : (
                  <>
                    {isConfirmBooked && !isMobile && renderContent()}

                    {ridersFound && !isMobile && renderButtons}
                  </>
                )}
              </>
            )}
          </div>
        </>
        {/* )} */}

        {/* Mobile Bottom Sheet */}

        {/* Mobile Bottom Sheet */}
        {isMobile && (
          <>
            <Sheet
              isOpen={isOpen}
              onClose={() => setIsOpen(false)}
              // snapPoints={[800,600, 400, 100]}
              snapPoints={[600, 400, 100]}
              initialSnap={0}
              onSnap={(snapIndex) => setCurrentSnap(snapIndex)}
              dragVelocityThreshold={currentSnap === 0 || 1 || 2 ? 9999 : 0}
              dragCloseThreshold={currentSnap === 0 || 1 || 2 ? 9999 : 0}
              // dragVelocityThreshold={ 0}
              // dragCloseThreshold={0}
              // root={document.getElementById('sheet-root')}
            >
              <Sheet.Container>
                <Sheet.Header
                  style={{
                    cursor: currentSnap === 2 ? "ns-resize" : "grab",
                  }}
                />
                {/* <Sheet.Content
                  style={{
                    paddingBottom: ref1.current?.y,
                    maxHeight: "90vh", // Ensure max height for better scrolling
                    minHeight: "400px", // Ensure it doesn't shrink too small
                    overflow: "hidden", // Prevent content overflow issues
                  }}
                > */}
                <Sheet.Content
                  style={{ paddingBottom: ref.current?.y }}
                  onPointerDown={(e) => {
                    if (currentSnap === 2 && e.target === e.currentTarget) {
                      e.stopPropagation();
                    }
                  }}
                >
                  <Sheet.Scroller
                    draggableAt={currentSnap === 2 ? "top" : "both"}
                  >
                    {showForm && !isConfirmBooked && (
                      <div className="p-4">
                        <h3 className="text-lg font-semibold mb-2">
                          Select Date & Time
                        </h3>

                        <div className="grid grid-cols-2 gap-4 mb-4">
                          {/* Date Input */}
                          <div>
                            <label className="text-sm font-semibold text-gray-700">
                              Date
                            </label>
                            <input
                              type="date"
                              name="date"
                              value={selectedDate}
                              onChange={(e) => setSelectedDate(e.target.value)}
                              className="w-full p-2 border rounded"
                              min={getTodayDate()}
                              max={getMaxDate()}
                              onKeyDown={(e) => e.preventDefault()}
                              onFocus={(e) => e.target.showPicker()}
                            />
                            {errors.date && (
                              <p className="text-red-500 text-sm">
                                {errors.date}
                              </p>
                            )}
                          </div>

                          {/* Time Input */}
                          <div>
                            <label className="text-sm font-semibold text-gray-700">
                              Time
                            </label>
                            <input
                              type="time"
                              name="time"
                              value={selectedTime}
                              onChange={handleTimeChange}
                              className="w-full p-2 border rounded"
                            />
                            {/* {errors.time && (
                          <p className="text-red-500 text-sm">{errors.time}</p>
                        )} */}
                            {timeError && (
                              <p className="text-red-500 text-sm mt-1">
                                {timeError}
                              </p>
                            )}
                          </div>
                        </div>
                        <input
                          type="text"
                          placeholder="Pickup Location"
                          value={pickupLocation.title}
                          readOnly
                          className="w-full p-2 border rounded mb-2 cursor-pointer"
                          onClick={() => {
                            setShowPickupMap(true);
                            setActiveType("pickup");
                            setIsOpen(false);
                          }}
                        />
                        {errors.pickup && (
                          <p className="text-red-500 text-sm">
                            {errors.pickup}
                          </p>
                        )}

                        {/* {showPickupMap && (
                    <div className="fixed inset-0 z-50">
                    <PickupMap
                      API_KEY={API_KEY}
                      pickupLocation={pickupLocation}
                      setPickupLocation={setPickupLocation}
                      setShowPickupMap={setShowPickupMap}
                      polygonCoordinates={polygonCoordinates}
                    />
                    </div>
                  )} */}
                        <ToggleButton
                          onSelect={(value) => setAcType(value)}
                          defaultValue={acType}
                        />
                        <PersonCount
                          value={personsCount}
                          onChange={setPersonsCount}
                        />
                        {errors.personsCount && (
                          <p className="text-red-500 text-sm">
                            {errors.personsCount}
                          </p>
                        )}
                        <CruzeTypes
                          capacity={personsCount}
                          onSelect={handleSelectCruze}
                          isAutoBid={
                            selectedPackageDetails?.biddingConfiguration
                              ?.isAutoBid
                          }
                        />
                        <button
                          className="w-full py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition duration-300"
                          // onClick={() => {
                          //   if (!isLoggedIn) {
                          // If user is not logged in, open authentication modal
                          // toggleAuthModal(); // Open the authentication modal
                          onClick={handlePrepaidOfferClick}
                          // } else {
                          //   // Handle booking or further action when logged in
                          //   handleConfirmBooking();
                          // }
                          // }}
                        >
                          Get Prepaid Offers
                        </button>

                        <button
                          className="w-full py-2 mt-2 text-gray-600 underline pb-5"
                          onClick={() => {
                            setShowForm(false);
                            setIsOpen(false);
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    )}

                    {ridersFound === false && isConfirmBooked && isMobile ? (
                      <>
                        <div className="flex justify-center items-center min-h-[40vh]">
                          <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
                            <NoOnlineDrivers
                              goBackToBooking={() =>
                                goBackToBookingFromNoDriver()
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        {stopSearch &&
                        notifiedRiders?.length === 0 &&
                        isConfirmBooked ? (
                          <>
                            <SearchStopped
                              onClose={() => goBackToBookingFromNoDriver()}
                            />
                          </>
                        ) : (
                          <>
                            {isConfirmBooked && isMobile && renderContent()}

                            {/* {ridersFound && isMobile && renderButtons} */}
                          </>
                        )}
                      </>
                    )}

                    {/* {isConfirmBooked && renderContent()} */}
                    {/* <div className="fixed bottom-0 left-0 w-full bg-white p-4 border-t shadow-lg z-50">
                  {ridersFound && renderButtons}
                </div> */}
                  </Sheet.Scroller>
                </Sheet.Content>
                {/* Sticky Buttons Inside the Bottom Sheet */}
                {/* {ridersFound && (
                <div
                  className="sticky bottom-0 left-0 w-full bg-white p-4 border-t shadow-lg z-50"
                  style={{ zIndex: 10 }}
                >
                  {renderButtons}
                </div>
              )} */}
                {/* <Sheet.Footer className="border-t shadow-lg z-10"> */}
                <div className="fixed bottom-0 left-0 w-full bg-white border-t shadow-lg z-10">
                  {ridersFound && isMobile && renderButtons}
                </div>
                {/* </Sheet.Footer> */}
              </Sheet.Container>
              <Sheet.Backdrop />
            </Sheet>

            {showPickupMap && (
              <div className="fixed inset-0 z-50">
                <PickupMap
                  API_KEY={API_KEY}
                  pickupLocation={pickupLocation}
                  // setPickupLocation={setPickupLocation}
                  setShowPickupMap={setShowPickupMap}
                  polygonCoordinates={polygonCoordinates}
                  setIsOpen={setIsOpen}
                />
              </div>
            )}
          </>
        )}
        {/* {isConfirmBooked && renderContent()} */}
        {!LoggedInState && (
          // <AuthModal
          //   isOpen={isAuthOpen}
          //   onClose={toggleAuthModal}
          //   onLoginSuccess={() => setIsLoggedIn(true)}
          // />
          <AuthModal
            isOpen={isAuthOpen}
            onClose={() => {
              toggleAuthModal();
              // Restore form state after successful login
              if (
                LoggedInState &&
                localStorage.getItem("attemptingBooking") === "true"
              ) {
                setShowForm(true);
                if (isMobile) {
                  setIsOpen(true);
                }
              }
            }}
            onLoginSuccess={() => {
              setIsLoggedIn(true);
              // Keep form data visible after login
              setShowForm(true);
              if (isMobile) {
                setIsOpen(true);
              }
            }}
          />
        )}

        {/* <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-60"> */}
        <ConfirmationModal
          isVisible={modalCancelVisible}
          title="Cancel Booking?"
          message="Are you sure you want to cancel and go back?"
          confirmLabel="Yes"
          cancelLabel="No"
          confirmColor="bg-red-600"
          cancelColor="bg-gray-300"
          onConfirm={() => handleBackConfirmation(true)}
          onCancel={() => {
            handleBackConfirmation(false);
            setIsOpen(true);
          }}
        />
        {/* </div> */}
      </div>
    );
  },
);

export default BookTour;
